import { sensorGraphConstants } from "../../constants/client";

const initialState = {};

export default function sensorGraph(state = initialState, action) {
  let oldstate = state;
  let currentstate = false;

  switch (action.type) {
    case sensorGraphConstants.LISTING_REQUEST:
      currentstate = {
        //paginationOptions: null,
        list: null,
        update_required: null,
        loading: true,
      };
      break;
    case sensorGraphConstants.LISTING_SUCCESS:
      currentstate = {
        list: action.payload.list,
        loading: false,
      };
      break;
    case sensorGraphConstants.BULK_LISTING_REQUEST:
      currentstate = {
        bulkList: [],
        loading: true,
      };
      break;
    case sensorGraphConstants.BULK_LISTING_SUCCESS:
      currentstate = {
        bulkList: action.payload.list,
        loading: false,
      };
      break;
    case sensorGraphConstants.LISTING_FAILURE:
      currentstate = { error: action.payload, loading: false };
      break;

    default:
      break;
  }

  if (currentstate) {
    return { ...oldstate, ...currentstate };
  } else {
    return oldstate;
  }
}
